import styles from "../../../../styles/SelectPaymentBlock.module.scss";
import { useEffect, useRef, useState, useMemo } from "react";
import { Tooltip } from 'bootstrap';
import paymentsHistoryClient from "../../../../utility/apiClients/account/paymentsHistoryClient";
import Globals, { URLS } from "../../../../utility/constants/appConstants";
import { formatDateMMDDYYYY, formatDateYYYYMMDD } from "../../../../utility/utils/dateUtil";
import { amountFormatter } from "../../../../utility/utils/formatter";
import { useSelector, useDispatch } from "react-redux";
import accountDetails from "../../../../utility/apiClients/account/accountDetailsClient";
import Loader from "../../../loader";
import InvoicesPopUp from "../../../ui/InvoicesPopUp";
import ToolTip from '../../../ui/toolTip';
import { setCustomerDetails } from "../../../../reduxStore/myAccount/getCustomerDetails";
import Error from "../../../errorMessage";
import NoPaymentDue from "../noPaymentDue";
import { Pagination } from "../../../Pagination";
import "../../../../styles/pagination.css";
import { encryptData } from '../../../../utility/utils/hashing';

if (global.window) {
  var $ = window.$;
}

const SelectPaymentBlock = (props) => {
  const dispatch = useDispatch();
  const labels = Globals.acc;
  const [refresh, setRefresh] = useState(0);
  const [salesAgreements, setSalesAgreements] = useState(null);
  const [popupData, setPopupData] = useState({});
  const [donations, setDonations] = useState([]);
  const [donationAmt, setDonationAmt] = useState(0);
  const [error, setError] = useState("");
  const [checkedMap, setCheckedMap] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [oneTimePage, setOneTimePage] = useState(1);

  const { setHasSelection, setParentLoading, isParentLoading } = props;

  const getServiceKey = (s, idx) => props.oneTime?s.invoiceNumber+"_"+idx:s.salesAgrNum+"_"+idx;
  const allCustomersApiCalled = useSelector((state) => state.login.allCustomersApiCalled);
  const donationRef = useRef(null);
  const modalRef = useRef(null);
  const customerSummary = useSelector((state) => state.login.customerInfo);
  const selectedServiceAddress = useSelector((state) => state.accountSummary.selectedServiceAddress);

  /* get current selected customer no. with service address */
  const [serviceAddress, customerNumber] = useMemo(() => {
    let custNumber = "";
    let serviceAddr = "";
    if(selectedServiceAddress != null){
      [serviceAddr, custNumber] = selectedServiceAddress.split(" | ");
    } else {
      custNumber = customerSummary?customerSummary[0].CustomerNumber:"";
      serviceAddr = customerSummary?customerSummary[0].ServiceAddresses[0].address:"";
    }
    return [serviceAddr, custNumber];
  }, [selectedServiceAddress, customerSummary]);

  const oneTimeInvoices = useMemo(() => {
    if (!props.oneTime || !salesAgreements || salesAgreements.length === 0) {
      return [];
    }

    const groupedInvoices = {};

    salesAgreements.forEach((item, idx) => {
      const invoiceNumber = item?.invoiceNumber;
      if (!invoiceNumber) return;

      const lineAmount = Number(item?.totalAmt ?? item?.invoice?.invoiceBalance ?? 0) || 0;
      const lineDesc = item?.svcDescription || item?.desc || "";
      const rawKey = getServiceKey(item, idx);

      if (!groupedInvoices[invoiceNumber]) {
        groupedInvoices[invoiceNumber] = {
          invoiceNumber,
          totalDue: 0,
          invoice: item?.invoice,
          salesAgrNum: item?.salesAgrNum,
          ticketLink: item?.ticketLink,
          invoiceOpen: item?.invoiceOpen,
          date: item?.date,
          desc: item?.desc,
          serviceLines: [],
          rawKeys: [],
        };
      }

      groupedInvoices[invoiceNumber].totalDue += lineAmount;
      groupedInvoices[invoiceNumber].serviceLines.push({
        desc: lineDesc,
        amount: lineAmount,
      });
      groupedInvoices[invoiceNumber].rawKeys.push(rawKey);
    });

    return Object.values(groupedInvoices);
  }, [props.oneTime, salesAgreements]);

  const oneTimePageSize = 10;
  const oneTimeTotalItems = oneTimeInvoices.length;
  const showOneTimePagination = oneTimeTotalItems > oneTimePageSize;

  const oneTimePageData = useMemo(() => {
    const start = (oneTimePage - 1) * oneTimePageSize;
    const end = start + oneTimePageSize;
    return oneTimeInvoices.slice(start, end);
  }, [oneTimeInvoices, oneTimePage]);

  useEffect(() => {
    if (!props.oneTime) return;
    const totalPages = Math.max(1, Math.ceil(oneTimeTotalItems / oneTimePageSize));
    if (oneTimePage > totalPages) {
      setOneTimePage(totalPages);
    }
  }, [props.oneTime, oneTimePage, oneTimeTotalItems]);

  useEffect(() => {
    setError("");
    
    if(isParentLoading.isCustomerSummaryApiLoaded === true && isParentLoading.isSaleAgreementApiLoaded === false){
      if(allCustomersApiCalled)
        (async () => await salesAgreementsClient())();
    }

  }, [isParentLoading.isCustomerSummaryApiLoaded, allCustomersApiCalled]);

  useEffect(() => {
    const paymentList = salesAgreements && salesAgreements
      .filter((s, i) => checkedMap[getServiceKey(s, i)])
      .map((s, i) => ({
        id: getServiceKey(s, i),
        name: s.svcLineDesc || s.svcDescription,
        price: s.AveragePricePerService || s?.invoice?.invoiceBalance || 0,
      }));
    const checkedData = [{ successData: [], listData: paymentList }];
    sessionStorage.setItem("paymentlist", JSON.stringify(checkedData));

    if (props.oneTime) {
      const selectedInvoiceKeys = oneTimeInvoices
        .filter((invoice) => checkedMap[invoice.invoiceNumber])
        .flatMap((invoice) => invoice.rawKeys);

      props.setSalesAgreementNumbers({
        ...props.salesAgreementNumbers,
        value: selectedInvoiceKeys,
      });

      setSelectAll(
        oneTimeInvoices.length > 0 &&
          oneTimeInvoices.every((invoice) => checkedMap[invoice.invoiceNumber])
      );
      setHasSelection(selectedInvoiceKeys.length > 0);
      return;
    }

    if(salesAgreements?.length > 0 && paymentList.length > 0 && salesAgreements?.length === paymentList.length){
      setSelectAll(true);
    }

    let checkedKeys = [];
    for(let i in checkedMap){
      if(checkedMap[i]){
        checkedKeys.push(i);
      }
    }

    props.setSalesAgreementNumbers({ 
      ...props.salesAgreementNumbers,
      value: checkedKeys
    });
    
  }, [checkedMap, salesAgreements, oneTimeInvoices]);

  useEffect(() => {
    handleRefresh();
  }, [props.salesAgreementNumbers, donationAmt]);

  // Initialize Bootstrap 5 tooltips
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

    if(salesAgreements?.length > 0){
      if (props.oneTime) {
        setCheckedMap({});
        setSelectAll(false);
        setHasSelection(false);
        props.setSalesAgreementNumbers({
          ...props.salesAgreementNumbers,
          value: [],
        });
      } else {
        /* by default all items will be selected */
        const allChecked = {};
        salesAgreements.forEach((s, i) => {
          allChecked[getServiceKey(s, i)] = true;
        });
        setCheckedMap(allChecked);
        setHasSelection(true);
      }
    }
    
    // Cleanup function to dispose tooltips when component unmounts
    return () => {
      tooltipList.forEach(tooltip => tooltip.dispose());
    };
  }, [salesAgreements]);

  const salesAgreementsClient = async () => {
    const encryptedCustNo = customerNumber ? encryptData(`${customerNumber}__customervalue${Date.now()}`, "customerNumber") : '';
    const formatedCustomerNumber = encryptedCustNo.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

    const response = await accountDetails(customerNumber, undefined);
    if (response && response.SalesAgreements && response.SalesAgreements.length > 0 ) {
      dispatch(setCustomerDetails(response));
      
      let openSalesAgr = [];
      let salesAgrs = [];

      if (props.oneTime) {
        if (response.SalesAgreements.length >= 1) {
          response.SalesAgreements.forEach((sa) => {
            let salesnumber = sa.salesAgrNum;
            let serviceDesc = sa.svcLineDesc;

            sa.Invoices.forEach((invoice) => {
              if (invoice.invoiceOpen === "Y") {
                let formattedDate = formatDateYYYYMMDD(
                  invoice.workOrderSvcDate
                );
                let urlDate = formattedDate.replace(
                  /(\d\d\d\d)(\d\d)(\d\d)/,
                  "$1/$2/$3"
                );
                let invoiceBalance = invoice.invoiceBalance
                  .toString()
                  .split(".");
                let invAmtIntPart = Globals.currencySymbol + invoiceBalance[0];
                let invAmtFractPart = invoiceBalance[1]
                  ? invoiceBalance[1].length < 2
                    ? invoiceBalance[1] + "0"
                    : invoiceBalance[1].substring(0, 2)
                  : "00";
                let dateMMDDYYYY = formatDateMMDDYYYY(invoice.workOrderSvcDate);
                const encryptedWONo = customerNumber && invoice.workOrderRef ? encryptData(invoice.workOrderRef + `__documentvalue${Date.now()}`, "serviceWorkOrder") : "";

                openSalesAgr.push({
                  invAmtIntPart,
                  invAmtFractPart,
                  salesAgrNum: salesnumber,
                  svcDescription: serviceDesc,
                  invoice: invoice,
                  ticketLink: customerNumber && invoice.workOrderRef ? `${process.env.REACT_APP_CMS_URL}/document/commercial/${formatedCustomerNumber}/workordernumber/${encryptedWONo}` : '',
                  invoiceNumber: invoice.invoiceNum,
                  invoiceOpen: invoice.invoiceOpen,
                  date: dateMMDDYYYY,
                  desc: invoice.svcDescription,
                  totalAmt: Number(invoice.invoiceBalance) || 0,
                });
              }
            });
          });
        }
        if (openSalesAgr.length < 1) {
          props.showNoPayment(true);
        } else {
          const data = openSalesAgr.reduce(
            (acc, s, i) => Object.assign(acc, { [s.invoiceNumber+"_"+i]: s }),
            {}
          );
          props.setSalesAgreementNumbers({ value: [], data });
        }
        
      } else {
        salesAgrs = response.SalesAgreements.filter(
          (item) =>
            item.inactiveStatus === "ACT" &&
            item.PrePay &&
            item.PrePay.length > 0
        );
        if (salesAgrs.length < 1) {
          props.showNoPayment(true);
        }
        

        let value = salesAgrs.map((item, i) => item.salesAgrNum+"_"+i);
        let data = salesAgrs.reduce(
          (acc, s, i) => Object.assign(acc, { [s.salesAgrNum+"_"+i]: s }),
          {}
        );
        props.setSalesAgreementNumbers({ value, data });
        
      }

      
      props.setHideClass(true);
      //handleRefresh();

      setSalesAgreements(props.oneTime ? openSalesAgr : salesAgrs);
      //setDonations(donationsSorted);
    } else if (
      response.CODE === "ER" ||
      (response.SalesAgreements && response.SalesAgreements.length === 0)
    ) {
      //const customerNumber = customerNumber;
      let openSalesAgr = [];

      const resPaymentHistory = await paymentsHistoryClient(customerNumber);

      if (resPaymentHistory && resPaymentHistory.invoices) {
        let selectedInvoiceData = resPaymentHistory.invoices.filter(
          (d) => d.invoiceBalance > 0
        );
        if (selectedInvoiceData.length >= 1) {
          selectedInvoiceData.forEach((invoice) => {
            let salesnumber = invoice.salesAgrNum;
            let serviceDesc = invoice.svcDescription;

            if (invoice.invoiceOpen === "Y") {
              let formattedDate = formatDateYYYYMMDD(invoice.workOrderSvcDate);
              let urlDate = formattedDate.replace(
                /(\d\d\d\d)(\d\d)(\d\d)/,
                "$1/$2/$3"
              );
              let invoiceBalance = invoice.invoiceBalance.toString().split(".");
              let invAmtIntPart = Globals.currencySymbol + invoiceBalance[0];
              let invAmtFractPart = invoiceBalance[1]
                ? invoiceBalance[1].length < 2
                  ? invoiceBalance[1] + "0"
                  : invoiceBalance[1].substring(0, 2)
                : "00";
              let dateMMDDYYYY = formatDateMMDDYYYY(invoice.workOrderSvcDate);
              const encryptedWONo = customerNumber && invoice.workOrderRef ? encryptData(invoice.workOrderRef + `__documentvalue${Date.now()}`, "serviceWorkOrder") : "";

              openSalesAgr.push({
                invAmtIntPart,
                invAmtFractPart,
                salesAgrNum: salesnumber,
                svcDescription: serviceDesc,
                invoice: invoice,
                ticketLink: customerNumber && invoice.workOrderRef ? `${process.env.REACT_APP_CMS_URL}/document/commercial/${formatedCustomerNumber}/workordernumber/${encryptedWONo}` : '',
                invoiceNumber: invoice.invoiceNum,
                invoiceOpen: invoice.invoiceOpen,
                date: dateMMDDYYYY,
                desc: invoice.svcDescription,
                totalAmt: Number(invoice.invoiceBalance) || 0,
              });
            }
          });
        }
      }
      props.setHideClass(true);
      setHasSelection(false);
      props.showNoPayment(true);
    } else if (response?.errorStatus === 424 || response?.errorStatus === 500) {
      setError("Some error occurred.");
      setHasSelection(false);
      setSalesAgreements([]);
      props.setSalesAgreementNumbers({ value: [], data: {} });
      dispatch(setCustomerDetails(null));
    }

    setParentLoading((prev) => ({
      ...prev,
      isSaleAgreementApiLoaded : true
    }));
  };  
  

  const handleServiceClick = (id) => {
    setSelectAll(false);
    const newmapChecked = { ...checkedMap, [id]: !checkedMap[id] };
    setCheckedMap(newmapChecked);
    const checkedCount = newmapChecked ? Object.values(newmapChecked).filter(Boolean).length : 0;
    setHasSelection(checkedCount > 0);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    const allChecked = {};
    if (newSelectAll) {
      if (props.oneTime) {
        oneTimeInvoices.forEach((invoice) => {
          allChecked[invoice.invoiceNumber] = true;
        });
      } else {
        salesAgreements.forEach((s, i) => {
          allChecked[getServiceKey(s, i)] = true;
        });
      }
      setCheckedMap(allChecked);
      props.setSalesAgreementNumbers({
        ...props.salesAgreementNumbers,
        value: props.oneTime
          ? oneTimeInvoices.flatMap((invoice) => invoice.rawKeys)
          : salesAgreements.map((s, i) => getServiceKey(s, i)),
      });
    } else {
      setCheckedMap({});
      props.setSalesAgreementNumbers({ 
        ...props.salesAgreementNumbers,
        value: []
      });
    }

    const checkedCount = allChecked ? Object.values(allChecked).filter(Boolean).length : 0;
    setHasSelection(checkedCount > 0);
  };

  const handleRefresh = () => {
    setRefresh((prev) => prev + 1);
    if (props.totalAmount && typeof props.totalAmount === "function") {
      const finalAmtSet = amountFormatter(getFinalTotal());
      props.totalAmount(finalAmtSet);
    }
  };

  const getFinalTotal = () => {
    const field = props.salesAgreementNumbers;
    const amt = props.oneTime
      ? field.value.reduce(
          (acc, agrNum) => acc + field.data[agrNum]?.invoice?.invoiceBalance,
          0
        ) + donationAmt
      : field.value.reduce(
          (acc, agrNum) => acc + field.data[agrNum]?.PrePay?.[0]?.yiaTotalAmt,
          0
        ) + donationAmt;
        
    return amt.toFixed(2);
  };

  const getFinalDisc = () => {
    const field = props.salesAgreementNumbers;
    const totaldisc = field.value.reduce(
      (acc, agrNum) => acc + field.data[agrNum]?.PrePay?.[0]?.yiaDiscAmt,
      0
    );
    return Math.abs(totaldisc);
  };

  const handlePopUp = (e) => {
    e.preventDefault();
    let invoiceNumber = e.target.getAttribute("invoicenum");
    let selectedInvoiceData = salesAgreements.filter(
      (d) => d.invoiceNumber === invoiceNumber
    );
    setPopupData(selectedInvoiceData);
    if (modalRef.current) {
      window.$(modalRef.current).modal("show");
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    if (modalRef.current) {
      window.$(modalRef.current).modal('hide');
    }
  }

  const finalAmt = amountFormatter(getFinalTotal());
  const finalDisc = !props.oneTime ? amountFormatter(getFinalDisc()) : '';
  
  return (
    <>
      {error !== "" && <Error labels={labels} errMsg={error} />}
      {error === "" && salesAgreements && salesAgreements.length > 0
       ?
        isParentLoading.isSaleAgreementApiLoaded ? (
          <>
            <div className={`${styles["mb-20"]} row`}>
              <div className='col-12'>
                <div className='align-items-center d-flex'>
                  <div>
                    {!props.oneTime && <input type='checkbox' className={`${styles["mr-10"]} ${styles["select-all-check"]}`} onChange={handleSelectAll} checked={selectAll} />}
                  </div>
                  {!props.oneTime && <label className='gfs-20 gfw-3 m-0 select-all-label' htmlFor='selectAllCheckbox'>{labels.selectAll}</label>}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className={`col-12  ${!props.oneTime ? styles["tru-mma-main-content-box"] : ""}`}>
                {!props.oneTime && salesAgreements.map((item, i) => {
                  const key = getServiceKey(item, i);
                  const prepay = item?.PrePay?.[0];
                  const agrAmount = amountFormatter(prepay?.salesAgrAmount + prepay?.salesAgrTaxAmount);
                  const totalAmt = amountFormatter(prepay?.yiaTotalAmt);
                  const isChecked = !!checkedMap[key];
                  return (
                    <div className={`row ${styles["border-bottom"]}  ${styles["mb-md-0"]}`} key={`agreement-${i}`}>
                      <div className={`align-items-center ${styles["border-bottom"]} col-12 col-md-8 col-lg-9 d-flex ${styles["gfw-3"]} ${styles["p-30"]} pref-service text-center text-md-left`}>
                        <div className='align-items-center d-flex'>
                          <div>
                            <input
                              type='checkbox'
                              className={`${styles["mr-10"]} ${styles["select-all-check"]}`}
                              checked={isChecked}
                              onChange={() => handleServiceClick(key)}
                            />
                          </div>
                          <label className={`${styles["gfs-24"]} ${styles["gfw-3"]} ${styles["glh-1"]} m-0 select-all-label`} htmlFor='salesAgreementNumbers'>{item.svcLineDesc}</label>
                        </div>
                      </div>
                      <div className={`${styles["bg-white"]} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end text-center text-lg-left p-0 position-relative ${styles["tru-mma-main-side"]}`}>
                        <div className={`align-items-center d-flex flex-column flex-fill justify-content-center ${styles["p-10"]}`}>
                          <span className={`d-block ${styles["gfs-14"]} ${styles["gfs-lg-16"]} ${styles["text-grey"]}`}>{labels.payNow}</span>
                          <span className={`d-block ${styles["gfs-14"]} ${styles["gfs-lg-16"]} ${styles["g-text-strike"]} ${styles["text-grey"]}`}>{Globals.currencySymbol}{agrAmount.dollars}<sup>{agrAmount.cents}</sup></span>
                          <span className={`d-block ${styles["gfs-md-40"]} ${styles["gfw-7"]} ${styles["glh-1_2"]} ${styles["text-green"]}`}>
                            <span>{Globals.currencySymbol}{totalAmt.dollars}</span>
                            <sup className={`${styles["gfs-md-22"]}`}>{totalAmt.cents}</sup>
                          </span>
                        </div>
                        <ToolTip  toolTip={''} tooltipdata={labels.prepaytooltips} tooltipsmbl={labels.tooltipsmbl} parentCss={styles} />
                      </div>
                    </div>
                  );
                })}
                {props.oneTime && (
                  <div className={styles["one-time-open-invoice"]}>
                    {/* <div>
                      <h3>Open Invoices</h3>
                      <p className={styles["one-time-subtext"]}>May not include all pending invoices.</p>
                    </div> */}

                    <div className={styles["one-time-invoice-container"]}>
                      {oneTimePageData.map((invoice) => {
                        const totalDue = amountFormatter(invoice.totalDue);
                        const isChecked = !!checkedMap[invoice.invoiceNumber];
                        const firstPart = invoice.serviceLines.slice(0, 2);
                        const secondPart = invoice.serviceLines.slice(2);
                        const seeMore = secondPart.length > 0;

                        return (
                          <div key={invoice.invoiceNumber} className={styles["one-time-invoice-box"]}>
                            <div className={styles["one-time-invoice-box-content"]}>
                              <div className={`${styles["one-time-form-check-label"]} d-flex gap-2 align-items-center`}>
                                <label htmlFor={`due-pay-${invoice.invoiceNumber}`} className='m-0 d-flex'>
                                  <input
                                    type='checkbox'
                                    id={`due-pay-${invoice.invoiceNumber}`}
                                    className={styles["one-time-checkmark"]}
                                    onChange={() => handleServiceClick(invoice.invoiceNumber)}
                                    checked={isChecked}
                                  />
                                </label>
                                <span>Invoice number:  <a href='#' className={styles["one-time-view-invoice"]} invoicenum={invoice.invoiceNumber} onClick={handlePopUp}>
                                  {invoice.invoiceNumber}
                                </a></span>
                              </div>

                              <div className={styles["one-time-due-amount"]}>
                                Total Due: <span>{Globals.currencySymbol}{totalDue.dollars}.{totalDue.cents}</span>
                              </div>

                              <div className={styles["one-time-due-date"]}>
                                <div className={styles["one-time-invoice-no"]}>
                                  {firstPart.map((line, idx) => {
                                    const lineAmount = amountFormatter(line.amount);
                                    return (
                                      <p className={styles["one-time-due-amount"]} key={`${invoice.invoiceNumber}-line-${idx}`}>
                                        {line.desc}: <span>{Globals.currencySymbol}{lineAmount.dollars}.{lineAmount.cents}</span>
                                      </p>
                                    );
                                  })}
                                </div>
                                <div
                                  style={{textAlign:'end'}}
                                >
                                  <span className={styles["one-time-see-more"]} data-bs-toggle="modal" data-bs-target={`#invoice-lines-${invoice.invoiceNumber}`}>{seeMore ? "See more" : ""}</span>
                                </div>
                              </div>

                              {/* <div className={styles["one-time-invoice-link-row"]}>
                                <a href='#' className={styles["one-time-view-invoice"]} invoicenum={invoice.invoiceNumber} onClick={handlePopUp}>
                                  {labels.invoiceLabel}{invoice.invoiceNumber}
                                </a>
                              </div> */}
                            </div>

                            {seeMore && (
                              <div className='modal fade' id={`invoice-lines-${invoice.invoiceNumber}`} data-bs-backdrop='static' role='dialog' tabIndex='-1' aria-hidden='true'>
                                <div className='modal-dialog modal-dialog-centered' role='document'>
                                  <div className='modal-content'>
                                    <div className='modal-header border-0'>
                                      <div className='modal-title'>
                                        <h5 className='modal-title'>Invoice Details</h5>
                                      </div>
                                      <button className='btn-close leadform-close-btn' aria-label='Close' type='button' data-bs-dismiss='modal'></button>
                                    </div>

                                    <div className='modal-body p-0'>
                                      <div className='container'>
                                        <div className='row'>
                                          <div className='col-12'>
                                            <div className={styles["one-time-modal-lines"]}>
                                              {secondPart.map((line, idx) => {
                                                const lineAmount = amountFormatter(line.amount);
                                                return (
                                                  <p className={styles["one-time-due-amount"]} key={`${invoice.invoiceNumber}-more-${idx}`}>
                                                    {line.desc}: <span>{Globals.currencySymbol}{lineAmount.dollars}.{lineAmount.cents}</span>
                                                  </p>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {showOneTimePagination && (
                      <div className='pagination-container'>
                        <Pagination
                          currentPage={oneTimePage}
                          totalItems={oneTimeTotalItems}
                          pageSize={oneTimePageSize}
                          onPageChange={setOneTimePage}
                          maxButtons={7}
                        />
                      </div>
                    )}
                  </div>
                )}
                
                {props.oneTime && <input type='hidden' name='DonationCode' value='SJ0' id='DonationCode' />}
              </div>
            </div>
            <InvoicesPopUp modalRef={modalRef} labels={labels} handleCloseModal={handleClose} data={popupData} serviceDetailsCss={styles} approachScreen={props.oneTime ? 'oneTime' : 'recurring'}/>
            <div className={`justify-content-end row ${styles["mb-20"]} ${styles["mt-md-10"]}`}>
              <div className={`bg-dark col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end text-center ${styles["text-lg-left"]} ${styles["bg-dark-pay-now"]} p-0 ${styles["tru-mma-main-side"]}`}>
                <div className='align-items-center d-flex flex-column flex-fill justify-content-center p-10'>
                  {!props.oneTime && <span className={`d-block ${styles["gfs-14"]} ${styles["gfs-lg-16"]} ${styles["text-white"]}`}>{labels.payNow}</span>}
                  {props.oneTime && <span className={`d-block ${styles["gfs-14"]} ${styles["gfs-lg-16"]} ${styles["text-white"]}`}>{labels.totalPayment}</span>}
                  <span className={`d-block ${styles["gfs-50"]} ${styles["gfs-md-40"]} ${styles["gfw-7"]} ${styles["glh-1_2"]} ${styles["text-green"]}`}>
                    <span>{Globals.currencySymbol}{finalAmt.dollars}</span>
                    <sup className={`${styles["gfs-md-22"]} tg-ml-6`} id='centAmount'>{finalAmt.cents}</sup>
                  </span>
                  {!props.oneTime && <span className='d-block gfs-14 gfs-lg-16 text-white'>
                    {labels.savingAmtText} <span id='discountDollarAmount'>{Globals.currencySymbol}{finalDisc.dollars}</span>
                    <sup>
                      {finalDisc.cents}
                    </sup>
                  </span>}
                </div>
              </div>
            </div>
          </>
        ) : <></>
       : salesAgreements === null
         ? <NoPaymentDue labels={labels} />
         : <></>
      }
    </>
  );
};

export default SelectPaymentBlock;
